import React, { Component, Fragment } from "react";
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';

class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: this.props.value ? this.props.value : "",
      onChangeFlag: this.props.value?true:false,
    };
  }

  onChange = (e) => {
    const { suggestions } = this.props;
    const userInput = e.currentTarget.value;
    this.setState({
      userInput: e.currentTarget.value,
      onChangeFlag: true,
    });
    if (userInput.length > 1) {
      const filteredSuggestions = suggestions.filter(
        (suggestion) =>
          suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
      );

      this.setState({
        activeSuggestion: 0,
        filteredSuggestions,
        showSuggestions: true,
        userInput: e.currentTarget.value,
      });

      this.props.onChangeSetCode(e.currentTarget.innerText);
    }
  };

  onClick = (e) => {
    this.setState({
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: e.currentTarget.innerText,
      onChangeFlag: false,
    });
    this.props.onChangeSetCode(e.currentTarget.innerText);
  };

  onKeyDown = (e) => {
    const { activeSuggestion, filteredSuggestions } = this.state;

    if (e.keyCode === 13) {
      this.setState({
        activeSuggestion: 0,
        showSuggestions: false,
        userInput: filteredSuggestions[activeSuggestion],
      });
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion - 1 });
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }
      this.setState({ activeSuggestion: activeSuggestion + 1 });
    }
  };

  render() {
    const {
      onChange,
      onClick,
      onKeyDown,
      state: {
        activeSuggestion,
        filteredSuggestions,
        showSuggestions,
        userInput,
      },
    } = this;

    let suggestionsListComponent;

    if (showSuggestions && userInput) {
      if (filteredSuggestions.length) {
        suggestionsListComponent = (
          <ul className="list-group" style={{ height: "130px", overflowY: "scroll", padding: "4px", position: "absolute", zIndex: 1000, width: "100%" }}>
            {filteredSuggestions.map((suggestion, index) => {
              let className = index === activeSuggestion ? "active" : "";
              return (
                <li
                  key={suggestion}
                  className={`list-group-item ${className}`}
                  onClick={onClick}
                  style={{ color: "white", background: "grey", padding: "4px", cursor: "pointer" }}
                >
                  {suggestion}
                </li>
              );
            })}
          </ul>
        );
      } else {
        suggestionsListComponent = (
          <div className="no-suggestions">
            <em>No suggestions available.</em>
          </div>
        );
      }
    }

    return (
      <Fragment>
        <FormGroup controlId={this.props.id}>
          
          <FormControl
            type="text"
            name={this.props.name}
            value={this.props.flag && !this.state.onChangeFlag ? "" : userInput}
            onChange={onChange}
            onKeyDown={onKeyDown}
            style={{
              border: "1px solid #808080ad",
              paddingTop: "3px",
              borderRadius: "5px",
              marginTop: "4px"
            }}
          />
          {suggestionsListComponent}
        </FormGroup>
      </Fragment>
    );
  }
}

export default Autocomplete;


